// Sample localization module following Copilot guidelines.
import { ILanguageResources, ITranslationModule } from '../interfaces';
import { interpolate } from '../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.modules.sample.';
  public static readonly defaultDialogButtonOk = `${Id.prefix}defaultDialogButtonOk`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangSampleModule {
  private constructor() {
    // do not create instances
  }

  public static defaultDialogButtonOk(): string {
    return interpolate(Id.defaultDialogButtonOk);
  }
}

export class SampleModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // Dialog Buttons
    register.add(Id.defaultDialogButtonOk, 'OK', 'Default dialog button OK');
  }
}
